var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"待结算订单"}},[_c('Wait')],1),_c('el-tab-pane',{attrs:{"label":"已结算订单"}},[_c('Accomplish')],1),_c('el-tab-pane',{attrs:{"label":"结算关闭订单"}},[_c('Close')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }